angular.
    module('app').
    component('authorization', {  // This name is what AngularJS uses to match to the `<phone-list>` element.
        templateUrl: '../Frontend/WipCustomersPortal/src/partials/authorization.template.html',
        controller: ['$scope', '$http', '$translate', '$filter', '$timeout', AuthorizationController],
        bindings: {
            login: '<'
        }
});

function AuthorizationController($scope, $http, $translate, $filter, $timeout){

    $scope.statusSuccess = false
    if (typeof infoData !== 'undefined') {
        $scope.Namespace = infoData.NameSpace;
        $scope.GymID = infoData.GymID;
    }else{
        $scope.Namespace = namespace;
        $scope.GymID = gymid;
    }

    $scope.logoLink = '/account/indexv2?namespace=' + $scope.Namespace + '&GymID=' + $scope.GymID;
    var $translateThis = $filter('translate');
    $scope.registerView = registerView;
    $scope.dashLogin = registerView ? false : true;

    if(typeof newRegistration !== 'undefined' && newRegistration){
        var translated = $translateThis('You email address is confirmed.');

        const Toast = Swal.mixin({
            toast: true,
            position: 'top',
            target: 'body #unauthenticated-form',
            showConfirmButton: false,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })
          
        Toast.fire({
            icon: 'success',
            type: 'success',
            title: translated
        })
    }
    
    if(typeof successNoComfirmation !== 'undefined' && successNoComfirmation){
        var translated = $translateThis('You successfully registered. Log in.');

        const Toast = Swal.mixin({
            toast: true,
            position: 'top',
            target: 'body #unauthenticated-form',
            showConfirmButton: false,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })
          
        Toast.fire({
            icon: 'success',
            type: 'success',
            title: translated
        })
    }



    $scope.closePopup = function () {
		$('.popup-wrapper').removeClass('show');
		$scope.formLogin.$setPristine();
        $scope.formRegister.$setPristine();
	}

    if ( isMobile ){
        $scope.mobileApp = isMobile;
    }
    
    if (gym)
        $scope.gym = gym;

    if (learnedFrom)
        $scope.learnedFrom = learnedFrom

    var $translateThis = $filter('translate');

    $scope.showLogin = function () {
        $scope.dashLogin = true;
    }

    $scope.hideLogin = function () {
        $scope.dashLogin = false;
    }

    $scope.phoneFormat = $scope.gym[0].Culture.includes('GB') ? /^[0-9\s]{5,11}$/ : /^[0-9]{5,15}$/;


    // Get Gyms
    getGyms = function () {
        var dataObject = {
            Namespace: $scope.Namespace
        }

        $http({
            method: 'POST',
            url: '/Membership/GetGyms',
            data: dataObject
        }).success(function (data) {
            $scope.membershipGyms = data;
            
            //$scope.$apply();

            if ($scope.membershipGyms.length == 1) {
                $timeout(function () {
                    $scope.RegGymName = $scope.membershipGyms[0].GymID;
                })
            }
        }).error(function () {
            // console.log('error');
        });
    }

    getGyms();

    $scope.accRegister = function () {
        $scope.statusSuccess = false;
        $scope.loading = true;
        $scope.currentLang = $translate.proposedLanguage() || $translate.use();
        var GymID = $scope.GymID;
        var Namespace = $scope.Namespace;
        var regbirthdate = $('#RegBirthdate').val();
        if ($scope.gym[0].Culture != 'en-US') {
            var res = regbirthdate.split("/");
            var date = res[1] + '/' + res[0] + '/' + res[2];
        }else{
            var date = regbirthdate;
        }
        var number = $scope.inputPhone.selectedDialCode.innerHTML + $scope.inputPhone.telInput.value;
        number = number.replace(/ /g,'');
        let url = window.location.pathname.split("/");
        let controller = url[1];
        let action = url[2];

        var dataObject = {
            RegEmail: $('#RegEmail').val(),
            RegPassword: $('#RegPassword').val(),
            RegConfirmPassword: $('#RegConfirmPassword').val(),
            RegFirstName: $('#RegFirstName').val(),
            RegLastName: $('#RegLastName').val(),
            Namespace: $scope.Namespace,
            GymID: $scope.GymID,
            Male: $scope.regSexRadio,
            Telephone: number,
            DivisionID: $('#RegGym').val(),
            Birthdate: moment(date).toISOString(),
            LearnedFrom: $('#RegLearnedFrom').val(),
            WorkAddress: $('#RegWorkAddress').val(),
            HomeAddress: $('#RegAddress').val(),
            RecommendBy: $('#RegRecommendBy').val(),
            Controller: controller,
            Action: action,
            ReceiveMarketingEmails: $('#checkboxMarketingEmailsLink').is(':checked'),
            PortalVersion: 'v2'
        }

        $http({
            method: 'POST',
            url: '/account/register/',
            data: dataObject
        }).success(function (data) {
            var data = data;

            if (data == 'Success') {

                if( $('.newbooking-body').length ){
                    $scope.statusSuccess = true;
                }else{
                    var currentHref = window.location;
                    var href = currentHref.origin + '/Account/ConfirmYourEmailv2?nameSpace=' + $scope.Namespace + '&gymId=' + $scope.GymID;
                    if ( isMobile == true ) {
                        href += '&isMobile=true';
                    }  
                    if ( registerView == true ) {
                        href += '&RegisterViewSuccess=true';
                    }  

                    window.location.replace(href);   
                }
            } else if ( data == 'SuccessNoConfirmation'){
                const currentHref = window.location;
                const href = currentHref.origin + '/Account/indexV2?nameSpace=' + $scope.Namespace + '&gymId=' + $scope.GymID + '&successNoComfirmation=true';
                window.location.replace(href);  
            } else {
                var n = data.search(" is already taken.");

                if (n > 0) {
                    var translated = $translateThis('User Taken');
                    $('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
                } else {
                    var res = data.split(".");

                    if (res.length > 2) {
                        $('.validation-errors').html('<div class="section-valid"></div>');
                        for (var i = 0; i < res.length - 1; i++) {
                            var msg = res[i] + '.';
                            var translated = $translateThis(msg);
                            $('.validation-errors .section-valid').append('<p>' + translated + '</p>');
                        }
                    } else {
                        var translated = $translateThis(data);
                        $('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
                    }
                }
            }
            $scope.loading = false;

        }).error(function () {
            // console.log('error');
        });
    };

    $scope.RememberMe = false;

    $scope.accLogin = function () {

        $scope.loading = true;
        var gymid = $('#accGymID').val();
        var namespace = $('#Namespace').val();

        var dataObject = {
            Email: $('#Email').val().replace(/ /g,''),
            Password: $('#Password').val(),
            RememberMe: $scope.RememberMe,
            Namespace: namespace,
            GymID: gymid
        }

        $http({
            method: 'POST',
            url: '/account/login/',
            data: dataObject
        }).success(function (data) {
            var data = data;
            var currentHref = window.location;
            // var href = currentHref.origin + '/Account/Dashboard?nameSpace=' + namespace + '&gymId=' + gymid;

            if (data == 'Success') {
                window.location.reload();
            } else {
                var translated = $translateThis(data);
                $('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
            }
            $scope.loading = false;

        }).error(function () {
            // console.log('error');
        });
    };


    function setCookie(key, value) {
        var val = value;
        var expires = new Date();
        expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
        if (val != "true") {
            $('body').addClass('pound-currency');
        } else {
            $('body').removeClass('pound-currency');
        }
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    var today = new Date();
    var datepicker = $('#RegBirthdate');
    var lastDate = getCookie('setDate');

    // Calculate the date 14 years ago from today
    var todayDate = new Date();
    var minAgeDate = new Date(todayDate.getFullYear() - 14, todayDate.getMonth(), todayDate.getDate());
    datepicker.datepicker({
        changeMonth: true,
        changeYear: true,
        yearRange: "1920:2040",
        numberOfMonths: 1,
        maxDate: minAgeDate,
        onSelect: function (dateText, inst) {
            $scope.currentLang = $translate.proposedLanguage() || $translate.use();
            var date = $(this).val();

            if ($scope.gym[0].Culture != 'en-US') {
                var res = date.split("/");
                var date = res[1] + '/' + res[0] + '/' + res[2];
            }
            $scope.cardStartDate = new Date(date);
            $scope.membershipStartDate = $scope.cardStartDate;

            if ($('.section-authorize').length && !$('#RegBirthdayVal').is(':checked')) {
                $('#RegBirthdayVal').trigger('click');
            }
            
            if ( $('.onepage-wrapper').length ) {
                $scope.theChoosenMembershipDate = $scope.cardStartDate;
            }
            $scope.$apply();
        }
    });
    $('.ui-datepicker').addClass('notranslate');
    $scope.currentLang = $translate.proposedLanguage() || $translate.use();

    datepicker.next('i').on('click', function () {
        datepicker.datepicker('show');
    });


    if ($scope.currentLang == 'en') {
        datepicker.datepicker("option", $.datepicker.regional['en']);
    }else if ($scope.currentLang == 'es' || $scope.currentLang == 'esc' || $scope.currentLang == 'esm'){
        datepicker.datepicker("option", $.datepicker.regional['es']);
    }else if ($scope.currentLang == 'pt'){
        datepicker.datepicker("option", $.datepicker.regional['pt']);
    }else if ($scope.currentLang == 'it'){
        datepicker.datepicker("option", $.datepicker.regional['it']);
    }else if ($scope.currentLang == 'ro'){
        datepicker.datepicker("option", $.datepicker.regional['ro']);
    }else if ($scope.currentLang == 'lt'){
        datepicker.datepicker("option", $.datepicker.regional['lt']);
    }else if ($scope.currentLang == 'id'){
        datepicker.datepicker("option", $.datepicker.regional['id']);
    }else if ($scope.currentLang == 'de'){
        datepicker.datepicker("option", $.datepicker.regional['de']);
    }else if ($scope.currentLang == 'mk'){
        datepicker.datepicker("option", $.datepicker.regional['mk']);
    }else {
        datepicker.datepicker("option", $.datepicker.regional['bg']);
    }

    if ( $scope.gym[0].Culture == 'en-US' ) {
        datepicker.datepicker("option", "dateFormat", 'mm/dd/yy');
    }else{
        datepicker.datepicker("option", "dateFormat", 'dd/mm/yy');
    }

    // Get Language from backend settings
	function getLanguage(culture){
		let lang = culture.split('-');
		lang = lang[1].toLowerCase();
		return lang;
	}

    $(window).on('load', function () {

        let phoneLang = getLanguage($scope.gym[0].Culture);
        var inputInitPhone = document.querySelector("#RegPhone");

        if(inputInitPhone){

            if($scope.gym[0].Culture.includes('GB')){
                $('#RegPhone')
                .on('keydown', function (e) {
                    if(e.keyCode == 32){
                        return false;
                    }
                })
                .on('keyup', function (e) {
                    if(e.target.value.length == 4){
                        e.target.value = e.target.value += ' ';
                    }
                });
            }

            $scope.inputPhone = window.intlTelInput(inputInitPhone, {
                autoHideDialCode: false,
                preferredCountries: [phoneLang],
                separateDialCode: true
            });

            inputInitPhone.addEventListener("countrychange", function() {
                let countryinfo = $scope.inputPhone.getSelectedCountryData()
                if(countryinfo.dialCode == '44'){
                    inputInitPhone.value = inputInitPhone.value.split(' ').join('');
                    if(inputInitPhone.value.length > 4){
                        inputInitPhone.value = inputInitPhone.value.substring(0, 4) + " " + inputInitPhone.value.substring(4, 10);
                    }
                    $scope.phoneFormat = /^[0-9\s]{5,11}$/;
                    $('#RegPhone')
                    .on('keydown', function (e) {
                        if(e.keyCode == 32){
                            return false;
                        }
                    })
                    .on('keyup', function (e) {
                        if(e.target.value.length == 4){
                            e.target.value = e.target.value += ' ';
                        }
                    });
                }else{
                    inputInitPhone.value = inputInitPhone.value.split(' ').join('');
                    $scope.phoneFormat = /^[0-9]{5,15}$/;
                    $scope.waiverForm.Telephone.$validate()
                    $('#RegPhone')
                    .on('keydown', function (e) {
                        if(e.keyCode == 32){
                            return false;
                        }
                    })
                    .on('keyup', function (e) {
                        if(e.target.value.length == 4){
                            // e.target.value = e.target.value += ' ';
                        }
                    });
                }
            });
        }

        setTimeout(function() {
            var recaptchaKey = window.location.hostname.toLowerCase().includes('localhost')
                ? '6LfJyZQsAAAAAKxwyxLzvcu1hq7Ulajlf2YAHuyl'
                : googleRecaptchApiKey;

            grecaptcha.render("recaptcha", {
                'sitekey': recaptchaKey, 
                'callback': function (token) {
                    if(!document.getElementById('RegRecaptcha').checked)
                        $('#RegRecaptcha').trigger('click');
                },
                'expired-callback': function (token) {
                    if(document.getElementById('RegRecaptcha').checked)
                        $('#RegRecaptcha').trigger('click');
                }
            });
        }, 100);
        
    });
}